module.exports = __webpack_public_path__ + "img/banner_generic_top.93e5675b.jpg";